<template>
  <div class="relationshipBox">
    <v-row class="boxWhite px-md-10" no-gutters>
      <div class="boxedContent">
        <v-row no-gutters>
          <div class="flexBox">
            <img :src="asset('img/icon/icon-golf.png')" alt="golf" class="boxedContent pr-2 pb-0" />
            <h1 class="boxedContent pb-0 font-weight-bold">
              {{ (data && data.totalCoursePlayed) || 0 }}
            </h1>
          </div>
        </v-row>
        <h4 class="black--text"><translate>Golf courses played</translate></h4>
      </div>
      <div class="boxedContent">
        <v-row no-gutters>
          <div class="flexBox">
            <img
              :src="asset('img/icon/icon-golf-sticks.png')"
              alt="golf-sticks"
              class="boxedContent pr-2 pb-0"
            />
            <h1 class="boxedContent pb-0 font-weight-bold">
              {{ data && data.handicap ? `${data.handicap}` : 0 }}
            </h1>
          </div>
        </v-row>
        <h4 class="black--text"><translate>Handicap</translate></h4>
      </div>
    </v-row>
    <v-row class="boxBlue" no-gutters>
      <div class="boxedContent">
        <h1 class="font-weight-bold">{{ data.totalPost || 0 }}</h1>
        <p><translate>Posts</translate></p>
      </div>
      <div class="boxedContent">
        <h1 class="font-weight-bold">{{ data.totalFollow || 0 }}</h1>
        <p><translate>Followers</translate></p>
      </div>
      <div class="boxedContent">
        <h1 class="font-weight-bold">
          {{ (data && data.totalFollowing) || 0 }}
        </h1>
        <p><translate>Following</translate></p>
      </div>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "RelationCard",
  props: {
    data: {
      type: Object,
      default: {},
    },
  }
};
</script>

<style lang="scss">
.relationshipBox {
  position: absolute;
  top: -20px;
  right: 0;
  .boxWhite {
    background: white;
    color: #179d4e;
    justify-content: center;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    .boxedContent {
      padding: 12px;
    }
  }
  .boxBlue {
    background: #179d4e;
    color: white;
    justify-content: center;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    margin-top: 0 !important;
    .boxedContent {
      padding: 15px 20px;
    }
  }
  .boxedContent {
    display: inline-block;
    text-align: center;
    p {
      margin-bottom: 0;
    }
  }
  img {
    object-fit: contain;
  }
  .flexBox {
    display: flex;
  }

  @media screen and (max-width: 1264px) {
    position: static;
    margin-bottom: 30px;
  }

  @media screen and (max-width: 767px) {
    margin-bottom: 15px;
    .boxWhite {
      .boxedContent {
        padding: 2px 12px 7px;
      }
    }
    .boxBlue {
      .boxedContent {
        padding: 4px 15px 7px;
      }
    }
  }
}
</style>
